module.exports = __webpack_public_path__ + "media/images/voiturier-779ef48db73ce3f25b1c523581c66799.svg";